var lib_core      = require("lib-core");

var AbstractSelectable3dObjectModel = function (editorModel, allowedHandles) {
    lib_core.Model.call(this);
    var self = this;

    this.selectable = this.value("selectable");
    this.selectable(true);

    this.selected = this.value("selected", true);
    this.selected(false);

    this.selectable.onChange("deselect", function(val){
        if(!val){
            self.selected(false);
        }
    })

    this.handlesHovered = this.value("handlesHovered", true);
    this.handlesHovered(false);

    this.editorModel = editorModel;

    if(allowedHandles === undefined)
        allowedHandles = [];

    this.allowedHandleTypes = this.set("allowedHandleTypes", false);

    // turn list into set for faster lookup
    for(var i = 0; i < allowedHandles.length; i++){
        this.allowedHandleTypes.add(allowedHandles[i]);
    }

    this.attachedHandleModels = this.set("attachedHandleModels", false);
}

lib_core.inherit(AbstractSelectable3dObjectModel, lib_core.Model);
AbstractSelectable3dObjectModel.$class = "AbstractSelectable3dObjectModel";


AbstractSelectable3dObjectModel.prototype.select = function(){
    var self = this;

    if(!this.selectable()) return;
    
    this.selected(true);
    self = this;

    this.editorModel.selectionHandles.forEach(function(item){
        if(self.allowedHandleTypes.contains(item.handleId)){
            item.addSubject(self);
            self.attachedHandleModels.add(item);
        }
    });
}

AbstractSelectable3dObjectModel.prototype.deselect = function(){
    var self = this;

    this.selected(false);

    this.attachedHandleModels.forEach(function(item){
        item.removeSubject(self);
        self.attachedHandleModels.add(item);
    });
}

AbstractSelectable3dObjectModel.prototype.getPosition = function(){
    // handles might need this
}

AbstractSelectable3dObjectModel.prototype.getRotation = function(){
    // handles might need this
}


module.exports = AbstractSelectable3dObjectModel;